export enum AttachmentType {
  GalleryImage = 'galleryImage',
  WhiteboardImage = 'whiteboardImage',
  JiraAttachment = 'jiraAttachment', // used when receive attachment from jira
  TaskcardAttachment = 'taskcardAttachment'
}
